import { render, staticRenderFns } from "./JobPopover.vue?vue&type=template&id=9c1277b6&"
import script from "./JobPopover.vue?vue&type=script&lang=js&"
export * from "./JobPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports